import { useEffect, useState, useMemo } from "react";
import { Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const GlobalSearchInput = ({ position }) => {
  const { t } = useTranslation("common");
  const [searchCriteria, setSearchCriteria] = useState(undefined);
  const { oldAssetsSearchCriteria } = useSelector((state) => state.deliveries);
  const dispatch = useDispatch();
  position = "right";
  useEffect(() => {
    dispatch.deliveries.setOldAssetsSearchCriteria(searchCriteria);
  }, [searchCriteria]);
  const searchBoxPosition = useMemo(() => {
    const horizontalPosition = position
      ? position === "left"
        ? { marginRight: "auto" }
        : { marginLeft: "auto" }
      : { marginLeft: "auto" };
    return horizontalPosition;
  }, []);
  return (
    <Input
      icon="search"
      placeholder={t("search")}
      name="globalSearch"
      value={oldAssetsSearchCriteria}
      onChange={(e) => setSearchCriteria(e.target.value)}
      style={{
        marginBottom: "1.5rem",
        display: "flex",
        searchBoxPosition,
        maxWidth: "200px",
      }}
    />
  );
};

export default GlobalSearchInput;
